/**
 * Structure.tsx — /app/structure
 *
 * Structural map: gamma walls, flip zone, concentration, liquidity zones, SMC.
 * Organizes existing engine panels into a coherent structural view.
 */
import React, { useState } from 'react';
import { useStore }         from '../../store';
import { GammaPanel }       from '../../features/gamma/GammaPanel';
import { LiquidityPanel }   from '../../features/liquidity/LiquidityPanel';
import { SMCPanel }         from '../../features/smc/SMCPanel';
import { WatchlistSidebar } from '../../features/watchlist/WatchlistSidebar';
import { DEFAULT_SMC_OVERLAYS } from '../../types';

type Tab = 'gamma' | 'liquidity' | 'smc';

const TABS: { id: Tab; label: string }[] = [
  { id: 'gamma',     label: 'Gamma'     },
  { id: 'liquidity', label: 'Liquidity' },
  { id: 'smc',       label: 'Structure' },
];

export function Structure() {
  const { activeSymbol } = useStore();
  const [tab, setTab]    = useState<Tab>('gamma');
  const [smc, setSmc]    = useState(DEFAULT_SMC_OVERLAYS);
  const sym = activeSymbol ?? '';

  return (
    <div style={{ display: 'flex', minHeight: 0, flex: '1 1 0%', fontFamily: "'Courier New', monospace" }}>
      <aside style={{ width: 200, flexShrink: 0, borderRight: '1px solid #1A3050', overflowY: 'auto' }}>
        <WatchlistSidebar />
      </aside>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {/* Sub-tabs */}
        <div style={{ display: 'flex', borderBottom: '1px solid #1A3050', flexShrink: 0 }}>
          {TABS.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{
              padding: '8px 20px', background: 'none', border: 'none', cursor: 'pointer',
              fontSize: 10, letterSpacing: 1.5, fontFamily: 'inherit',
              color: tab === t.id ? '#C9A84C' : '#3A5070',
              borderBottom: tab === t.id ? '2px solid #C9A84C' : '2px solid transparent',
            }}>
              {t.label.toUpperCase()}
            </button>
          ))}
        </div>
        {/* Content */}
        <div style={{ flex: 1, overflowY: 'auto', padding: 16 }}>
          {sym ? (
            <>
              {tab === 'gamma'     && <GammaPanel symbol={sym} />}
              {tab === 'liquidity' && <LiquidityPanel symbol={sym} />}
              {tab === 'smc'       && <SMCPanel symbol={sym} overlays={smc} onOverlaysChange={setSmc} />}
            </>
          ) : (
            <div style={{ color: '#3A5070', textAlign: 'center', paddingTop: 60, fontSize: 11, letterSpacing: 2 }}>
              SELECT A SYMBOL
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
